export const config = {
	apiKey: "AIzaSyDkQ9WELGcPDcNS1lP8UfQ8g9XnLR8dqyw",
	authDomain: "swipe-app-sluisoord-de-mheen.firebaseapp.com",
	projectId: "swipe-app-sluisoord-de-mheen",
	storageBucket: "swipe-app-sluisoord-de-mheen.appspot.com",
	messagingSenderId: "432902600465",
	appId: "1:432902600465:web:6b4178443dad384392feb0",
};
